import React, {useState} from 'react';
import style from '../../../PaperworkList/PaperworkList.module.css';
import {toast} from 'react-toastify';
import act02 from '../../../../assets/img/icons/actions/gridicons_cross-circle.svg';
import act03 from '../../../../assets/img/icons/actions/el_pencil-alt.svg';
import act04 from '../../../../assets/img/icons/actions/fluent_print-28-filled.svg';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {useDeleteCashOrderMutation} from '../../../../redux/DepotSlice/depotCashierApi';
import TableButtonsActions, {
	ActionConfig,
} from '../../../../Components/TableButtonsActions/TableButtonsActions';
import {
	CashierOrderType,
	RequestCreateCashierOrderType,
	RequestEditCashierOrderType,
} from '../../../../types/CashierSliceStateType';
import CreateEditCashForm from '../../components/CreateEditCashForm';
import ModalWrapper from '../../../../Components/ModalWrapper/ModalWrapper';
import {handleApiCall} from '../../../../assets/utils/utils';

const CashierTableActions = ({order}: {order: CashierOrderType}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const [openEditPopup, setOpenEditPopup] = useState(false);
	const [initialValues, setInitialValues] =
		useState<RequestCreateCashierOrderType | null>(null);
	const [deleteOrder] = useDeleteCashOrderMutation();

	const handleClosePopup = () => {
		setOpenEditPopup(false);
	};
	const handlers = {
		delete: async (id: number) => {
			await handleApiCall({
				apiCall: () => deleteOrder(id),
				onSuccess: (data) => {
					toast.success(data.message?.textmsg || t('Успішно видалено'));
				},
				onError: (error) => {
					toast.error(error || t('Помилка при видаленні'));
				},
			});
		},
		edit: (id: number) => {
			// Переходимо на сторінку створення касового ордера з даними для редагування
			navigate('/create_cash_order', {
				state: {
					editData: {
						amount: `${order.amount} ${order.currency}`,
						account_id: order.account_id,
						comment: order.comment,
						order_id: id,
					}
				}
			});
		},
	};

	const actions: ActionConfig[] = [
		{
			type: 'delete',
			icon: act02,
			label: t('Видалити'),
			requiresConfirmation: true,
			confirmText: t('Ви дійсно хочете видалити замовлення?'),
			disabled: (status) => status !== 'new',
			handler: handlers.delete,
		},
		{
			type: 'edit',
			icon: act03,
			label: t('Редагувати'),
			disabled: (status) => status !== 'new',
			handler: handlers.edit,
		},
		{
			type: 'print',
			icon: act04,
			label: t('Друк'),
			disabled: () => true,
			handler: () => {
				console.log('print');
			},
		},
	];
	return (
		<>
			<div className={style.tableColumn}>
				<TableButtonsActions
					actions={actions}
					orderId={order.id}
					orderStatus={order.status}
				/>
			</div>
			{openEditPopup && initialValues && (
				<ModalWrapper handleClosePopup={handleClosePopup}>
					<CreateEditCashForm
						initialValues={initialValues}
						title={t('Редагувати касовий ордер')}
						type={'edit'}
						handleClosePopup={handleClosePopup}
					/>
				</ModalWrapper>
			)}
		</>
	);
};

export default CashierTableActions;
